/**
 * Tiny window-event bus so deeply-nested plan-lock hints (SourceWizard's
 * custom-source card, ScheduleWizard/ScheduleEditor's intro/outro hints)
 * can open the Pricing modal without prop-drilling a callback through
 * NewsSourceManager / ScheduleManager / Dashboard / App. App.js owns the
 * modal's mounted state and listens for this event once, at the top of the
 * tree; any component can call openPricingModal() to request it.
 */
export const PRICING_MODAL_OPEN_EVENT = 'lnc:open-pricing-modal';

export function openPricingModal() {
  window.dispatchEvent(new CustomEvent(PRICING_MODAL_OPEN_EVENT));
}
